import { useMutation } from "@apollo/client";

import {
  DeleteAllAnnotationsMutation,
  DeleteAllAnnotationsMutationVariables,
} from "../../../API";
import { DELETE_ALL_ANNOTATIONS } from "../../../common/operations/mutations";
import { handleApolloError } from "../../../common/utils/handleApolloError";
import { Reference } from "@apollo/client";

export const useDeleteAllAnnotations = () => {
  const [deleteAllAnnotationsMutation, { data, loading }] = useMutation<
    DeleteAllAnnotationsMutation,
    DeleteAllAnnotationsMutationVariables
  >(DELETE_ALL_ANNOTATIONS);

  const deleteAllAnnotations = async (serviceId: string) => {
    return await deleteAllAnnotationsMutation({
      variables: {
        input: {
          serviceId,
        },
      },
      update: (cache, { data }) => {
        if (data?.deleteAllAnnotations) {
          cache.modify({
            fields: {
              getAnnotations(existing = { items: [] }, { readField }) {
                const filteredItems = existing.items.filter(
                  (ref: Reference) => {
                    const refServiceId = readField("serviceId", ref);

                    return refServiceId !== serviceId;
                  }
                );

                return {
                  ...existing,
                  items: filteredItems,
                };
              },
            },
          });
        }
      },
      onError: handleApolloError,
      refetchQueries: ["GetAnnotations"],
    });
  };

  return { deleteAllAnnotations, data, loading };
};
